import { useRef } from 'react';
import { Dialog, DialogTitle, DialogContent } from '@efexteam/components';
import useCombineBalances from '@main-hooks/useCombinedBalances';
import useMobileAgent from '@main-hooks/useMobileAgent';
import CreateNewAccount from './components/CreateNewAccount';
import newWalletModalStyles from './NewWalletModal.style';
import CreatingAccount from './components/CreatingAccount';
import AccountCreated from './components/AccountCreated';
import { CreateWalletResponse } from './services/types';

import { NewWalletModalProps } from './types/NewWalletModal.types';
import useSteps from './hooks/useSteps';
import { STEPS } from './constants';

const NewWalletModal = ({
  setOpen,
  isOpen,
  addFunds,
  onConvert,
}: NewWalletModalProps) => {
  const { step, setStep } = useSteps({ isOpen });

  const selectedCurrency = useRef<{ currency: string; currencyName: string }>();
  const newWalletData = useRef<CreateWalletResponse | null>(null);

  const [isMobileDevice] = useMobileAgent();

  const { reloadWallet } = useCombineBalances();

  const handleClose = () => {
    setOpen(false);
    if (newWalletData.current !== null) reloadWallet();
  };

  const setSelectedCurrency = (currency: {
    currency: string;
    currencyName: string;
  }) => {
    selectedCurrency.current = currency;
  };

  return (
    <Dialog
      fullScreen={isMobileDevice}
      maxWidth={!isMobileDevice ? 'sm' : undefined}
      open={isOpen}
      onClose={handleClose}
    >
      <DialogTitle showCloseButton onClick={handleClose} />
      <DialogContent className={newWalletModalStyles.modalContainer}>
        {step === STEPS.ONE && (
          <CreateNewAccount
            onChangeSelectedCurrency={setSelectedCurrency}
            onGoToNextStep={() => setStep(STEPS.TWO)}
            onClose={handleClose}
          />
        )}

        {step === STEPS.TWO && (
          <CreatingAccount
            onGoToNextStep={(walletData) => {
              newWalletData.current = walletData;
              setStep(STEPS.THREE);
            }}
            selectedCurrency={
              selectedCurrency.current || { currency: '', currencyName: '' }
            }
          />
        )}

        {step === STEPS.THREE && (
          <AccountCreated
            onConvert={onConvert}
            addFunds={addFunds}
            newWalletData={newWalletData.current}
            currencyName={selectedCurrency.current?.currencyName || ''}
          />
        )}
      </DialogContent>
    </Dialog>
  );
};

export default NewWalletModal;
